import { render, staticRenderFns } from "./MenuPrimeClient.vue?vue&type=template&id=12aefd74&scoped=true&"
import script from "./MenuPrimeClient.vue?vue&type=script&lang=js&"
export * from "./MenuPrimeClient.vue?vue&type=script&lang=js&"
import style0 from "./MenuPrimeClient.vue?vue&type=style&index=0&id=12aefd74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aefd74",
  null
  
)

export default component.exports